import { render, staticRenderFns } from "./certificationLecturer.vue?vue&type=template&id=0e92e136"
import script from "./certificationLecturer.vue?vue&type=script&lang=js"
export * from "./certificationLecturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports